import { Icon } from './Icon'
import { cn } from '../../lib/cn'

interface SearchInputProps {
  value: string
  onChange: (v: string) => void
  placeholder?: string
  className?: string
  tone?: 'light' | 'dark'
  id?: string
}

export function SearchInput({ value, onChange, placeholder = 'Search…', className, tone = 'light', id }: SearchInputProps) {
  const dark = tone === 'dark'
  return (
    <div className={cn('relative', className)}>
      <Icon
        name="Search"
        className={cn('pointer-events-none absolute left-4 top-1/2 h-5 w-5 -translate-y-1/2', dark ? 'text-white/50' : 'text-ink-500')}
      />
      <input
        id={id}
        type="search"
        role="searchbox"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder} aria-label={placeholder}
        className={cn(
          'h-12 w-full rounded-full border py-3.5 pl-12 pr-11 text-[0.95rem] outline-none transition-colors focus:ring-2 focus:ring-lime-bright',
          dark
            ? 'border-white/15 bg-white/10 text-white placeholder:text-white/50'
            : 'border-sand-200 bg-white text-ink placeholder:text-ink-300',
        )}
      />
      {value && (
        <button
          type="button"
          onClick={() => onChange('')}
          aria-label="Clear search"
          className={cn(
            'absolute right-3 top-1/2 flex h-7 w-7 -translate-y-1/2 items-center justify-center rounded-full transition-colors',
            dark ? 'text-white/60 hover:bg-white/10' : 'text-ink-500 hover:bg-sand-100',
          )}
        >
          <Icon name="X" className="h-4 w-4" />
        </button>
      )}
    </div>
  )
}
